module.exports = __webpack_public_path__ + "img/orientation-vertical-off.1541bbb1.svg";